import React from 'react'
import { Card, Cards, CardButton } from 'components/Form'
import Button from 'components/Button'
import ButtonGroup from 'components/ButtonGroup'
import Center from 'components/Center'
import Modal, { ModalBody, ModalFooter } from 'components/Modal'
import PropTypes from 'prop-types'
import ErrorText from '../ErrorText/ErrorText'
import * as translationService from './../../services/translationService'
import isString from 'lodash/isString'

const isObjError = error => {
  return error === Object(error)
}
const isStringError = error => {
  return isString(error)
}

export default class CardSelector extends React.PureComponent {
  static propTypes = {
    types: PropTypes.array,
    onChange: PropTypes.func,
    onAdd: PropTypes.func,
    onRemove: PropTypes.func,
    id: PropTypes.string,
    values: PropTypes.any,
    action: PropTypes.string,
    title: PropTypes.string,
    error: PropTypes.any,
    field: PropTypes.any.isRequired,
  }
  state = {
    modalIds: [],
  }

  handleChange = event => {
    const { id, value } = event.target
    this.props.onChange(id, value)
  }

  modelSelectionChange = (event, { id }) => {
    const { checked } = event.target
    let { modalIds } = this.state
    if (!checked) {
      modalIds = modalIds.filter(item => item !== id)
    } else {
      modalIds.push(id)
    }

    this.setState({
      modalIds,
    })
  }

  toggleModal = () => {
    this.setState({
      modalIsOpen: !this.state.modalIsOpen,
    })
  }

  renderFieldCards = (type, index, error) => {
    if (!type) return null
    const value = this.props.values.find(value => value.id === type.id) || {}
    // const oldValue = this.props.values[type.id] || {}
    let props = {
      value: value.value,
      onChange: event => this.handleChange(event, value),
      id: type.id,
    }
    if (error && error[index]) {
      props.error = error[index].value
    }
    if (type.min !== undefined) {
      props.min = type.min
    }
    return (
      <Card
        title={translationService.t(type.id)}
        icon={type.icon}
        key={type.id}
        canRemove={!type.persist}
        onRemove={() => this.props.onRemove(type.id)}
        id={type.id}>
        {React.cloneElement(this.props.field, props)}
      </Card>
    )
  }

  renderInputCards = type => {
    const oldValue = this.props.values.find(value => value.id === type.id) || null

    if (!oldValue) {
      return (
        <Card title={translationService.t(type.id)} icon={type.icon} key={type.id} id={type.id}>
          <input type="checkbox" onChange={event => this.modelSelectionChange(event, type)} id={type.id} />
        </Card>
      )
    }
  }

  addSelectedOptions = () => {
    const { modalIds } = this.state

    this.props.onAdd(modalIds)
    this.closeModel()
  }

  closeModel = () => {
    this.setState({
      modalIds: [],
    })
    this.toggleModal()
  }

  render() {
    const { types, action, title, error, values } = this.props
    const extraCards = types.filter(type => !this.props.values.find(value => value.id === type.id))

    return (
      <div>
        <div>
          <Cards>
            {values &&
              values.map((value, index) => {
                const type = types.find(type => type.id === value.id)
                return this.renderFieldCards(type, index, isObjError(error) && error)
              })}
            {extraCards.length ? (
              <CardButton onClick={this.toggleModal} error={isStringError(error)}>
                + {action}
              </CardButton>
            ) : null}
          </Cards>
          {error && !isObjError(error) && <ErrorText transKey={error} />}
        </div>

        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModel}
          contentLabel="Example Modal"
          title={title}>
          <ModalBody>
            <Center>
              <Cards>{types && types.map(type => this.renderInputCards(type))}</Cards>
            </Center>
          </ModalBody>
          <ModalFooter>
            <ButtonGroup>
              <Button onClick={this.closeModel}>{translationService.buttonCancel()}</Button>
              <Button onClick={this.addSelectedOptions} primary>
                {translationService.buttonFinishedAdding()}
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CardSelector/index.js